import { render, staticRenderFns } from "./EmployeeReportComponent.vue?vue&type=template&id=2f32d4aa&"
import script from "./EmployeeReportComponent.vue?vue&type=script&lang=js&"
export * from "./EmployeeReportComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports